module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Groza_C.8b31cc37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Groza_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_Groza_C.png
// module chunks = 0